import Fuse from 'fuse.js';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import List from './components/List';
import Search from './components/Search';

export default function App(props) {
	const [appData, setAppData] = useState({});
	const [wordList, setWordList] = useState({});
	const [labelData, setLabelData] = useState({});
	const [searchTerm, setSearchTerm] = useState('');
	const [showSynonyms, setShowSynonyms] = useState(Boolean(1));
	const [filteredWordList, setFilteredWordList] = useState({});

	const fullWordList = (data) => {
		const wordList = {};

		Object.entries(data).forEach(([title, entry]) => {
			let tempName = entry.name;
			wordList[title.toLowerCase()] = {
				id: entry.id,
				url: entry.url,
				name: tempName,
				synonym: '',
			};
			entry.synonyms.forEach((synonym) => {
				if (synonym) {
					wordList[synonym.toLowerCase()] = {
						id: entry.id,
						url: entry.url,
						name: synonym,
						synonym: tempName,
					};
				}
			});
		});
		return wordList;
	};

	const handleSearch = (term) => {
		setSearchTerm(term);
		const test = showSynonyms ? wordList : appData;
		const list = Object.keys(test).map((key) => {
			return { id: key, data: test[key] };
		});

		const searchParams = {
			includeScore: true,
			includeMatches: true,
			keys: ['id'],
			ignoreLocation: true,
			threshold: 0.3,
		};

		const fuse = new Fuse(list, searchParams);
		let filtered = fuse.search(term);

		const filteredObject = filtered.reduce((acc, result) => {
			acc[result.item.id] = result.item.data;
			return acc;
		}, {});

		setFilteredWordList(filteredObject);
	};

	const getWordList = () => {
		if (searchTerm) {
			return filteredWordList;
		} else if (!searchTerm && showSynonyms) {
			return wordList;
		} else {
			return appData;
		}
	};

	useEffect(() => {
		// Fetch App Data via provided REST URL.
		fetch(props.dataUrl)
			.then((res) => res.json())
			.then((data) => {
				setAppData(data.words);
				setLabelData(data.labels);
				setShowSynonyms(Boolean(data.showSynonyms));
				setWordList(fullWordList(data.words));
			})
			.catch((error) => console.error(error));
	}, []);

	const canRender = () => appData && wordList;

	return canRender ? (
		<>
			<Search onSearch={handleSearch} labels={labelData} />
			<List synonyms={showSynonyms} label={labelData} searchTerm={searchTerm} wordList={getWordList()} />
		</>
	) : null;
}

App.propTypes = {
	dataUrl: PropTypes.string,
};
